class JsonToolException extends Error {}

export default JsonToolException;
